module.exports = __webpack_public_path__ + "static/media/Logo.1fdad738.svg";